import { InjectionToken } from '@angular/core';

export const VBRICK_PLAYER_HOST = new InjectionToken<any>(
	'VBRICK_PLAYER_HOST'
);
